import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SignupComponent } from './signup/signup.component';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../core/auth.service';
import {NgbAlertModule} from '@ng-bootstrap/ng-bootstrap';
import { NgxCaptchaModule } from 'ngx-captcha';

const routes: Routes = [
  { path: '', component: SignupComponent }];
@NgModule({
  declarations: [SignupComponent],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    NgxCaptchaModule,
    CommonModule,
    RouterModule.forChild(routes),
    NgbAlertModule
  ],
  providers: [AuthService]
})
export class SignupModule { }
